import { Dialog } from "antd-mobile";
import { useStores } from "../models";
import useNavigation from "./useNavigation";

const useCheckBinding = () => {
  const navigation = useNavigation();
  const { userStore, walletStore } = useStores();
  const { currentUser = {} as any } = userStore;
  const is_phone_verify =
    currentUser.is_phone_verify || walletStore?.is_phone_verify;
  const is_pay_password = currentUser.is_pay_password || walletStore?.pay_pwd;
  const is_id_verify = currentUser.is_id_verify || walletStore?.is_id_verify;

  const handleCheckBindingWpPassword = () => {
    return new Promise<{ message: string; type: string }>((resolve, reject) => {
      if (is_pay_password || walletStore?.pay_pwd) {
        resolve({ message: "已绑定支付密码", type: "success" });
      } else {
        Dialog.confirm({
          title: "提示",
          content: "请先设置支付密码",
          confirmText: "去设置",
          cancelText: "之后再说",
          onConfirm: () => {
            navigation.navigate("SettingPayNumber");
            reject({ message: "未设置支付密码", type: "fail" });
          },
          onCancel: () => reject({ message: "未设置支付密码", type: "fail" }),
        });
      }
    });
  };

  const handleCheckBindingPhone = () => {
    return new Promise<{ message: string; type: string }>((resolve, reject) => {
      if (is_phone_verify || walletStore?.is_phone_verify) {
        resolve({ message: "已绑定手机", type: "success" });
      } else {
        Dialog.confirm({
          title: "绑定提示",
          content: "请先绑定手机",
          confirmText: "前往绑定",
          cancelText: "之后再说",
          onConfirm: () => {
            Dialog.clear();
            navigation.navigate("PhoneBinding");
            reject({ message: "未绑定手机", type: "fail" });
          },
          onCancel: () => {
            Dialog.clear();
            reject({ message: "未绑定手机", type: "fail" });
          },
        });
      }
    });
  };

  const handleCheckBindingId = () => {
    return new Promise<{ message: string; type: string }>((resolve, reject) => {
      if (is_id_verify || walletStore?.is_id_verify) {
        resolve({ message: "已实名认证", type: "success" });
      } else {
        Dialog.confirm({
          title: "提示",
          content: "请先绑定实名认证,再进行下单",
          confirmText: "前往绑定",
          cancelText: "之后再说",
          onConfirm: () => {
            navigation.navigate("Verified");
            reject({ message: "未实名", type: "fail" });
          },
          onCancel: () => reject({ message: "未实名", type: "fail" }),
        });
      }
    });
  };

  return {
    handleCheckBindingWpPassword,
    handleCheckBindingPhone,
    handleCheckBindingId,
    is_phone_verify,
    is_pay_password,
    is_id_verify,
  };
};

export default useCheckBinding;
